import React from 'react';
import styled from '@emotion/styled';
import { EnHeading } from 'components/atoms/enHeading';
import { text } from 'style/mixin';
import { headerHeightPc, mq } from 'style/variables';

const CareerDetailTitleWrapper = styled.div`
  position: absolute;
  width: 1160px;
  height: 540px;
  display: flex;
  align-items: center;
  margin: ${headerHeightPc}px 10px 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;

  ${mq.onlysp} {
    left: 0;
    margin: 64px 32px 0;
    height: 374px;
    max-width: calc(100% - 32px);
    transform: none;
  }
`;

const PositionTitle = styled(EnHeading)`
  ${text(63.45, 0.96)}
  max-width: 600px;
  color: #242424;
  letter-spacing: 0.03rem;

  ${mq.onlysp} {
    ${text(40, 1)}
    letter-spacing: 0.012em;
  }
`;

export const CareerDetailTitle = ({ title }: { title: string }) => {
  return (
    <CareerDetailTitleWrapper>
      <PositionTitle>{title}</PositionTitle>
    </CareerDetailTitleWrapper>
  );
};
